import { C } from '../data/tokens.js';
import { Ico } from './Ico.jsx';

const TABS = [
  { id: "dashboard", label: "Reports", icon: "file" },
  { id: "pricing", label: "Pricing", icon: "tag" },
  { id: "costs", label: "Costs", icon: "dollar" },
  { id: "clients", label: "Clients", icon: "users" },
];

const HIDDEN_SCREENS = ["signup", "step1", "step2", "analyze", "review", "preview", "tierselect", "reportdetail"];

export function BottomTabs({ screen, go }) {
  if (HIDDEN_SCREENS.includes(screen)) return null;

  return (
    <div className="bottom-tabs">
      {TABS.map(tab => {
        const active = screen === tab.id || (tab.id === "clients" && screen === "clientdetail");
        return (
          <div key={tab.id} className={`bottom-tab ${active ? "active" : ""}`}
            onClick={() => go(tab.id)}>
            <Ico n={tab.icon} size={20} color={active ? C.gold : C.ghost} />
            <div className="bottom-tab-label">{tab.label}</div>
          </div>
        );
      })}
    </div>
  );
}
